<template>
  <a-modal
    v-if="isChatModelShow"
    :body-style="{ padding: 0 }"
    :footer="false"
    :visible="isChatModelShow"
    :width="910 + rightWidth + 'px'"
    @cancel="switchChatShow(false)"
  >
    <div class="modalBox">
      <LeftBanner />
      <ChatList ref="chatListItem" @switchUser="switchUser" />
      <div class="content">
        <div class="title">
          <!-- 分三种情况,
              企业对象: 用户名(公司名)
              个人用户: 用户名(手机号/邮箱)
              游客: 游客(ip地址 地址)
            -->
          <!-- 游客 -->
          <template v-if="!otherUserInfo.roleId">
            <span :title="$t('游客')" class="mainTitle"> {{ $t('游客') }} </span
            ><span v-if="otherUserInfo.userName || otherUserInfo.ipLocation" class="subTitle"
              >({{ otherUserInfo.userName }}
              {{ otherUserInfo.userName && otherUserInfo.ipLocation ? '/' : '' }}
              {{ otherUserInfo.ipLocation }})</span
            >
          </template>
          <!-- 企业对象 -->
          <!-- 如果companyflag返回0,说明是公司, 但后端有的接口没返回companyflag,所以另外用roleId判断 -->
          <template
            v-else-if="
              otherUserInfo.companyName &&
              (otherUserInfo.companyFlag === 0 ||
                Number(otherUserInfo.roleId) === 2 ||
                Number(otherUserInfo.roleId) === 3 ||
                Number(otherUserInfo.roleId) === 4)
            "
          >
            <span
              :title="otherUserInfo.userName || otherUserInfo.memberUserName || otherUserInfo.contact"
              class="mainTitle"
            >
              {{ otherUserInfo.userName || otherUserInfo.memberUserName || otherUserInfo.contact }} </span
            ><span v-if="otherUserInfo.companyName" class="subTitle">({{ otherUserInfo.companyName }})</span>
            <div class="purchaseIdentity">
              <div v-if="otherUserInfo.purchaserFlag === 1" class="buyer">
                {{ $t('采购商') }}
              </div>
              <div v-if="otherUserInfo.supplierFlag === 1" class="supplier">
                {{ $t('供应商') }}
              </div>
              <div v-if="otherUserInfo.allianceFlag === 1" class="alliance">
                {{ $t('加盟商') }}
              </div>
              <div v-if="otherUserInfo.brandFlag === 1" class="brand">
                {{ $t('品牌商') }}
              </div>
            </div>
          </template>
          <!-- 个人用户 -->
          <template v-else>
            <span class="mainTitle">
              {{ otherUserInfo.memberUserName || otherUserInfo.contact || otherUserInfo.userName }}
            </span>
            <span v-if="otherUserInfo.phone || otherUserInfo.email" class="subTitle">
              ({{
                otherUserInfo.phone
                  ? (otherUserInfo.phonearea ? `${otherUserInfo.phonearea} ` : '') + otherUserInfo.phone
                  : ''
              }}{{ otherUserInfo.phone && otherUserInfo.email ? ' / ' : '' }}{{ otherUserInfo.email }})
            </span>
            <div class="purchaseIdentity">
              <div v-if="otherUserInfo.purchaserFlag === 1" class="buyer">
                {{ $t('采购商') }}
              </div>
              <div v-if="otherUserInfo.supplierFlag === 1" class="supplier">
                {{ $t('供应商') }}
              </div>
              <div v-if="otherUserInfo.allianceFlag === 1" class="alliance">
                {{ $t('加盟商') }}
              </div>
              <div v-if="otherUserInfo.brandFlag === 1" class="brand">
                {{ $t('品牌商') }}
              </div>
            </div>
          </template>
        </div>
        <div class="chatMainBox">
          <div class="shadowBox" />
          <div class="left">
            <Message ref="message" @handleSendBtn="handleSendBtn" />
            <UserText ref="userText" @activationRightModule="activationRightModule" />
          </div>
          <div :style="{ width: rightWidth + 'px' }" class="right">
            <div v-if="rightModulesNow.length > 1" class="rightTabsBox">
              <div
                v-for="(data, index) in rightModulesNow"
                :key="index"
                :class="{
                  rightTabsBoxActivation: data.name === activationRightModuleName,
                }"
              >
                <span
                  style="display: inline-flex; height: 100%; align-items: center"
                  @click="activationRightModule(data.name)"
                >
                  {{ data.title }}
                </span>

                <a-icon
                  v-if="data.canDowm"
                  class="rightTabsBoxOutIcon"
                  type="close"
                  @click="downRightModule(data.name)"
                />
              </div>
            </div>

            <div class="rightModuleBox">
              <!-- 企业信息 -->
              <CompanyInfo
                v-if="judExistedModule('corporateInfo')"
                v-show="activationRightModuleName === 'corporateInfo'"
                :show-home-btn="showHomeBtn"
              />
              <!-- 企业信息 -->

              <!-- 采购邀请 -->
              <PurchaseInvitation
                v-if="judExistedModule('purchaseInvitation')"
                v-show="activationRightModuleName === 'purchaseInvitation'"
                @sendPurchase="handleSendPurchase"
              />
              <!-- 采购邀请 -->

              <!-- 消息记录 -->
              <ChatRecord
                v-if="judExistedModule('chatRecord')"
                v-show="activationRightModuleName === 'chatRecord'"
                :is-activation="activationRightModuleName === 'chatRecord'"
                :my-info="{
                  code: currentUser.unicode || currentUser.memunicode,
                  name: myUserName,
                  avatarUrl: selfAvatar,
                  nickname: myNickname,
                }"
                :other-side-info="{
                  code: otherUserInfo.huanxinId,
                  name: otherUserInfo.userName || otherUserInfo.memberUserName || otherUserInfo.contact,
                  avatarUrl:
                    ((otherUserInfo && (otherUserInfo.cardAvatar || otherUserInfo.memberAvatar)) || DEFAULTS_AVATAR) +
                    '?x-oss-process=image/resize,m_fixed,h_44,w_44',
                  nickname:
                    otherUserInfo.companyName && otherUserInfo.companyFlag === 0
                      ? otherUserInfo.companyName
                      : !otherUserInfo.roleId
                        ? `${otherUserInfo.userName} / ${otherUserInfo.ipLocation}`
                        : `${otherUserInfo.phonearea} ${otherUserInfo.phone}${
                            otherUserInfo.phone && otherUserInfo.email ? ' / ' : ''
                          }${otherUserInfo.email}`,
                }"
              />
              <!-- 消息记录 -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <PasteImgModal ref="pasteImg" />
  </a-modal>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Message from './components/Message.vue'
import UserText from './components/Text.vue'
import CompanyInfo from './components/CompanyInfo.vue'
import LeftBanner from './components/leftBanner.vue'
import ChatList from './components/chatList.vue'

import PasteImgModal from './components/pasteImgModal.vue'
import PurchaseInvitation from './components/PurchaseInvitation.vue'

import { postUpdateTalk } from '@/api/CompanyCloudSystem'
import { removeUnread, syncMsgUnReadNum } from '@/api/pushSend'
import { getUserPurchaseList } from '@/api/memberCenter/myPurchase'

// const
import { DEFAULTS_AVATAR, DEFAULTS_AVATAR_BIG, ICON_CHAT_DOT_RED } from '@/const/image'

import ChatRecord from '~/components/chat/components/ChatRecord.vue'

export default {
  name: 'ChatPage',
  components: {
    Message,
    UserText,
    CompanyInfo,
    LeftBanner,
    ChatList,
    ChatRecord,
    PasteImgModal,
    PurchaseInvitation,
  },
  props: {
    showHomeBtn: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      DEFAULTS_AVATAR_BIG,
      ICON_CHAT_DOT_RED,
      DEFAULTS_AVATAR,
      // 右侧模块 注册
      rightModulesEnrolment: {
        // 唯一name
        corporateInfo: {
          // 标题文本
          title: '基本信息',
          // 是否可关闭
          canDowm: false,
          // 所需宽度 px单位
          width: 305,
        },
        purchaseInvitation: {
          title: '采购邀请',
          canDowm: false,
          width: 305,
        },
        chatRecord: {
          // 标题文本
          title: '聊天记录',
          // 是否可关闭
          canDowm: true,
          // 所需宽度 px单位
          width: 500,
        },
      },
      // 右侧模块 实时
      rightModulesNow: [],
      // 激活的右侧模块名
      activationRightModuleName: undefined,
    }
  },
  computed: {
    ...mapState({
      adminUnReadNum: (state) => state.chat.adminUnReadNum,
    }),
    ...mapGetters({
      // 判断是否正式登录
      token: 'token',
      userInfo: 'userInfo',
      isChatModelShow: 'chat/isChatModelShow',
      modalMsgList: 'chat/modalMsgList',
      isWebIMLogin: 'chat/isWebIMLogin',
      currentUser: 'chat/currentUser',
      // 洽谈的全部未读数(不包括admin的数据)
      talkUnReadNum: 'chat/talkUnReadNum',
      msgList: 'chat/msgList',
      // 被洽谈角色信息
      currentSession: 'chat/currentSession',
      otherUserInfo: 'chat/otherUserInfo',
      visitorUser: 'chat/visitorUser',
      IMLoginInfo: 'chat/IMLoginInfo',
    }),
    rightWidth() {
      if (this.activationRightModuleName) {
        return this.rightModulesEnrolment[this.activationRightModuleName].width
      } else {
        return 0
      }
    },
    myNickname() {
      if (this.$store.state?.userInfo?.company && this.$store.state.userInfo.company.companyName) {
        return ''
      } else if (this.$store.state.userInfo.phone) {
        return this.$store.state.userInfo.phone + this.$store.state.userInfo.phone && this.$store.state.userInfo.email
          ? '/'
          : String(this.$store.state.userInfo.email)
      } else {
        return this.IMLoginInfo.ip || this.IMLoginInfo.nickname
      }
    },
    // 我的头像
    selfAvatar() {
      return (
        (this.$store.state.userInfo.company && this.$store.state.userInfo.company.logo) ||
        this.$store.state.userInfo.avatar
      )
    },
    // 我的用户名
    myUserName() {
      if (this.currentUser.company && this.currentUser.company.companyName) {
        return this.currentUser.company.companyName
      }
      if (this.currentUser.phone) {
        return this.currentUser.phone
      }
      if (this.currentUser.email) {
        return this.currentUser.email
      }
      return '未知用户名'
    },
  },
  watch: {
    /**
     * @description: 洽谈框显示与否
     * @param {*} val
     * @return {*}
     */
    isChatModelShow(isShow) {
      console.log('洽谈框显示与否', isShow, this.$store.state.userInfo, 'this.otherUserInfo', this.otherUserInfo)
      // modal弹出
      if (isShow) {
        if (this.$store.state.userInfo.memunicode === this.otherUserInfo.memunicode) {
          this.$message.error(this.$t('采购详情提示2'))
          this.switchChatShow(false)
          return
        }

        // 添加聊天列表滚动监听

        this.$nextTick(() => {
          console.log('洽谈框显示与否', this.$refs, this.$refs.chatListItem)
          this.$refs.chatListItem.chatListCurrent = 1
          this.$refs.chatListItem.hoverItem = -1
          this.switchChatShow('show')

          // 初次打开获取用户信息
          this.$store.commit('chat/INIT_CURRENT_USER', this.$store.state.userInfo)
          this.$store.commit('chat/INIT_SESSION_USER', this.otherUserInfo)
        })
      }
    },
    // 用户是否登录, 或者从中断情况恢复
    isWebIMLogin(status) {
      // 如果状态是成功, 且聊天框是显示的, 激活任务
      if (status && this.isChatModelShow) {
        this.chatInit()
      }
    },
  },
  mounted() {
    this.addRightModule('corporateInfo')
    this.addRightModule('purchaseInvitation')
    this.activationRightModule('corporateInfo')
  },
  methods: {
    // 重置右侧模块
    resetRightModule() {
      this.rightModulesNow = []
      this.addRightModule('corporateInfo')
      this.addRightModule('purchaseInvitation')
      this.activationRightModule('corporateInfo')
    },
    // 关闭一个模块
    downRightModule(moduleName) {
      if (!moduleName || !this.rightModulesEnrolment[moduleName]) {
        return
      }
      const newRightModulesNow = []
      this.rightModulesNow.forEach((data) => {
        if (data.name !== moduleName) {
          newRightModulesNow.push(data)
        }
      })
      this.rightModulesNow = newRightModulesNow
      console.log('newRightModulesNow')
      console.log(this.rightModulesNow[0].name)
      this.activationRightModule(this.rightModulesNow[0].name)
    },
    // 激活一个模块
    activationRightModule(moduleName) {
      if (!moduleName || !this.rightModulesEnrolment[moduleName] || this.activationRightModuleName === moduleName) {
        return
      }
      if (!this.judExistedModule(moduleName)) {
        this.addRightModule(moduleName)
      }
      this.activationRightModuleName = moduleName
    },
    // 添加右侧模块 ; moduleName string 模块name
    addRightModule(moduleName) {
      // 前置条件判断
      if (!moduleName || !this.rightModulesEnrolment[moduleName] || this.judExistedModule(moduleName)) {
        return
      }

      this.rightModulesNow.push({
        name: moduleName,
        ...this.rightModulesEnrolment[moduleName],
      })
    },
    // 判断是否已添加此模块 return Boolean
    judExistedModule(moduleName) {
      let existed = false
      this.rightModulesNow.forEach((data) => {
        if (data.name === moduleName) {
          existed = true
        }
      })
      return existed
    },

    /**
     * 获取对话历史消息
     * @param {Object} options
     * @param {String} options.queue   - 对方用户id（如果用户id内含有大写字母请改成小写字母）/群组id/聊天室id
     * @param {String} options.count   - 每次拉取条数
     * @param {Boolean} options.isGroup - 是否是群聊,默认为false
     * @param {Function} options.success
     * @param {Function} options.fail
     */
    /**
     * @description: 切换聊天框显示状态
     * @param {*} type show: 弹出框, 获取列表接口,  false关闭窗口
     * @return {*}
     */
    switchChatShow(type) {
      /**
       * 聊天框逻辑
       * 1. 获取聊天列表,且当前点击的用户为第一位
       * 2. 获取聊天信息
       */

      if (type === 'show') {
        // 如果打开聊天框, 且没有登录
        if (!this.token) {
          this.$store.commit('switchPopupLoginStatus', 'login')
          return
        }

        this.addRightModule('corporateInfo')
        this.addRightModule('purchaseInvitation')
        this.activationRightModule('corporateInfo')
        this.chatInit(type)
      } else {
        this.$store.commit('chat/RESET_CURRENT_SESSION')
        this.$store.commit('chat/switchChatModelShow', type)
        this.resetRightModule()
      }
    },
    /**
     * 切换用户
     * 检测用户是否联系过, 清理未读的消息, 且发送已读回执
     * */
    async switchUser() {
      console.log('切换用户方法 switchUser')
      this.resetRightModule()
      // 检测是否联系过
      if (this.token) {
        this.setIsContact(this.otherUserInfo)
      }

      // 更新用户信息
      this.$store.commit('chat/INIT_SESSION_USER', this.otherUserInfo)

      const modalMsgList = JSON.parse(JSON.stringify(this.modalMsgList))

      this.$refs.message.isGetAllData = false
      this.$refs.message.oldHistoryCurrent = 1

      // 清理浮点
      // this.$WebIM.conn.mr_cache = []

      if (
        (this.isWebIMLogin && this.otherUserInfo && !this.msgList.contact) ||
        !this.currentSession.id ||
        !this.msgList.contact[this.currentSession.id] ||
        (this.msgList.contact &&
          this.currentSession.id &&
          this.msgList.contact[this.currentSession.id] &&
          this.msgList.contact[this.currentSession.id].length < 10)
      ) {
        this.$refs.message.getHistoryMessages()
      }

      const hoverItem = this.$refs.chatListItem.hoverItem
      // 如果有未读, 清除未读信息
      if (modalMsgList[hoverItem]?.talkMessageLog?.unReadNum) {
        this.$store.commit(
          'chat/UPDATE_CHAT_UNREAD_NUM',
          this.talkUnReadNum - modalMsgList[hoverItem].talkMessageLog.unReadNum || 0,
        )

        modalMsgList[hoverItem].talkMessageLog.unReadNum = 0

        await syncMsgUnReadNum({ unReadNum: this.talkUnReadNum })

        this.$store.commit('chat/UPDATE_MODAL_MSG_LIST', modalMsgList)

        // 清除我们直接服务器的未读
        removeUnread({
          from: this.otherUserInfo.memunicode || this.otherUserInfo.memUnicode || this.otherUserInfo.huanxinId,
          to: this.userInfo.huanxinId || this.userInfo.memunicode,
        })
        const msg = new this.$WebIM.message('channel', this.$WebIM.conn.getUniqueId())

        setTimeout(() => {
          // 发送已读回执
          // 延后执行, 降低缓存

          const ToUser = this.otherUserInfo.memunicode || this.otherUserInfo.memUnicode || this.otherUserInfo.huanxinId

          console.log('msg 发送已读回执', msg)
          msg.set({
            to: Number(ToUser) || ToUser, // 接收消息对象（用户id）
            success(data) {
              // 发送整个会话已读
              console.log('发送整个会话已读', data)
            },
            fail(data) {
              console.log('发送整个会话已读err', data)
            },
          })
          this.$WebIM.conn.send(msg.body)
        }, 1000)
      }
    },
    // 设置为已联系
    async setIsContact() {
      const faceLinkInfo = this.otherUserInfo

      if (faceLinkInfo.lineStatus === 1) {
        return
      }

      const huanxinId = this.otherUserInfo.huanxinId || this.otherUserInfo.mchMemberHuanxinId

      const contantList = this.$store.getters['chat/contantList']
      if (huanxinId && !contantList.includes(huanxinId)) {
        const info = await postUpdateTalk({
          targetMemberCode: huanxinId,
        })
        console.log('postUpdateTalk', info)
        if (info.code === 0) {
          this.$store.commit('chat/addContantList', huanxinId)
        }
      }
    },
    /**
     * @description: 初始化洽谈, 获取聊天列表和切换用户
     * @param {*}
     * @return {*}
     */
    chatInit() {
      // 获取聊天列表
      this.$refs.chatListItem.getChatList()
      // 切换用户
      this.switchUser()
    },

    // 用于兄弟组件通信,
    handleSendBtn(msg) {
      this.$refs.userText.handleSendBtn({ type: 'resend', incomeMsg: msg })
    },
    handleSendPurchase(item) {
      console.log('Sending purchase item:', item)
      const msg = {
        content: '[采购邀请]',
        data: '[采购邀请]',
        yunhzhContentType: 'purchase',
        yunhzhContentProduct: { ...item }, // Pass the full item as requested
      }
      this.handleSendBtn(msg)
    },
  },
}
</script>
<style lang="scss" scoped>
.modalBox {
  position: relative;
  display: flex;
  border-radius: 6px;
  height: 760px;

  > .content {
    flex: 1;
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .title {
      @include text-ellipsis(2);
      position: relative;
      z-index: 5;
      width: 100%;
      height: 60px;
      // line-height: 60px;
      background: #ffffff;
      border-radius: 10px 6px 10px 10px;
      max-width: 800px;
      display: flex;
      align-items: center;

      .mainTitle {
        font-size: 20px;
        margin: 0 10px 0 20px;
        font-weight: 500;
        color: #444444;
        @include text-ellipsis(2);
      }

      .subTitle {
        font-size: 16px;
        font-weight: 400;
        color: #aaabad;
        // line-height: 42px;
      }

      .purchaseIdentity {
        margin-left: 10px;
      }
    }
  }
}

.chatMainBox {
  //box-shadow: 0px 12px 10px -15px rgb(0 0 0 / 30%);
  background: #eee;
  display: flex;
  flex: 1;
  position: relative;

  & > .shadowBox {
    width: 100%;
    height: 60px;
    //background-color: black;
    position: absolute;
    top: -60px;
    left: 0;
    z-index: 4;
    box-shadow: 0px 3px 12px 2px rgb(0 0 0 / 5%);
  }

  > .left {
    border-right: 1px solid #e0e0e0;
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    // height: 70vh;
    flex: 1;

    .user-text {
      height: 200px;
    }
  }

  > .right {
    position: relative;
    height: 100%;
    background: #fff;
    display: flex;
    flex-direction: column;

    .rightTabsBox {
      height: 40px;
      width: 100%;
      background-color: #f5f5f5;
      display: flex;

      & > div {
        height: 100%;
        padding: 0 20px 0 20px;
        display: flex;
        align-items: center;
        user-select: none;
        cursor: pointer;

        .rightTabsBoxOutIcon {
          margin-left: 6px;
          color: #a9a9a9;
          transition: all 0.3s;

          &:hover {
            color: rgba(0, 0, 0, 0.65);
          }
        }
      }

      .rightTabsBoxActivation {
        color: #ff6600;
        background-color: white;
      }
    }

    .rightModuleBox {
      flex: 1;
    }
  }
}

.purchaseIdentity {
  display: flex;

  > div {
    padding: 0 2px;
    height: 18px;
    line-height: 18px;
    color: #ffffff;
    border-radius: 2px;
    display: inline-block;

    margin-left: 4px;
    margin-right: 4px;

    &:nth-of-type(1) {
      margin-left: 0;
    }
  }

  .buyer {
    background: #3386f1;
  }

  .supplier {
    background: #ff6600;
  }

  .alliance {
    background: #f54342;
  }

  .brand {
    background: #485aeb;
  }
}
</style>
